import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { DefiTokensPage } from "../../features/defi/pages/defi-tokens-page";
import { stablecoinsSearchSchema } from "../../shared/utils/search-params-schema";

export const Route = createFileRoute("/_layout/defi/stablecoins/")({
  component: DefiTokensPage,
  validateSearch: zodValidator(stablecoinsSearchSchema),
});
